import React from 'react';
import { Table } from 'react-bootstrap';
import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import VirtualList from 'react-tiny-virtual-list';
import PropTypes from 'prop-types';

import ServiceItem from './Service';

const Body = ({ services, config, formData, onChangeRate, onChangePercent }) => {
  const showProviderColumn = config?.access?.see_provider_column;

  const isWindow = navigator?.userAgent?.includes('Win');

  return (
    <div className="services-rates__body">
      <div className="services-rates__table">
        <div className="services-rates__table-header">
          <Table>
            <thead>
              <tr>
                <th className="service-name">Service</th>
                {showProviderColumn && <th className="service-provider">Provider</th>}
                <th className="service-fixed">Fixed, 1.00</th>
                <th className="service-percent">Percent, %</th>
                <th className="service-rate">Current rate</th>
                <th className={`service-rate-new ${isWindow ? 'window' : ''}`}>New rate</th>
              </tr>
            </thead>
          </Table>
        </div>
        <AutoSizer>
          {({ height, width }) => (
            <VirtualList
              width={width}
              height={height - 45}
              itemCount={services?.length}
              itemSize={56}
              className="services-rates__table-list"
              renderItem={({ index, style }) => {
                const elem = services[index];

                if (elem.type === 'category') {
                  return (
                    <div key={index} style={style} className="list-item table-category">
                      <Table>
                        <tbody>
                          <tr style={{ height: style.height }}>
                            <td colSpan={showProviderColumn ? 6 : 5}>{elem.name}</td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  );
                }

                const serviceForm = formData.find((item) => item.id === elem.id);
                return (
                  <ServiceItem
                    service={elem}
                    serviceForm={serviceForm}
                    config={config}
                    onChangeRate={onChangeRate}
                    onChangePercent={onChangePercent}
                    showProviderColumn={showProviderColumn}
                    index={index}
                    style={style}
                    key={index}
                  />
                );
              }}
            />
          )}
        </AutoSizer>
      </div>
    </div>
  );
};

Body.propTypes = {
  services: PropTypes.array,
  config: PropTypes.object,
  formData: PropTypes.array,
  onChangeRate: PropTypes.func,
  onChangePercent: PropTypes.func,
};

export default Body;
